import { render, staticRenderFns } from "./checkbox_icon.vue?vue&type=template&id=736e1e73&lang=pug"
import script from "./checkbox_icon.vue?vue&type=script&lang=js"
export * from "./checkbox_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports